export default __webpack_public_path__ + "static/media/tune_upwards_techstack.39bc2243.jpg";